"use strict";

import PageCommon from "../PageCommon.js";
import Artist from "./Artist.js";

export default class Artists {
    constructor(props, formats) {
        this.formats = formats;
        this.data = props.map((item) => new Artist(item, this.formats));
        this.firstpage = {
            artists: [],
            producers: [],
        };
    }

    set(object) {
        this.data = object.map((item) => new Artist(item, this.formats));
    }

    get({ id }) {
        if (id) {
            return this.data.filter((artist) => artist.get().ID === parseInt(id))[0];
        }
        return this.data;
    }

    renderFirstpageList(format) {
        const container = document.querySelector(`#${format}Section`);
        const list = container.querySelector(".swiper-wrapper");
        list.textContent = "";
        const elements = 6;
        this.firstpage[format].map((id, index) => index < elements && list.appendChild(this.get({ id }).renderSwiperListItem()));
    }

    renderList(format, section) {
        const container = document.querySelector(`#${section}Section`);
        const list = container.querySelector(".list-wrapper");
        list.textContent = "";
        container.querySelector(".fm-section-header h4").textContent = format + "s";
        this.data.map((artist) => artist.data.Format === format && list.appendChild(artist.renderListItem()));
    }

    renderSwiperList(format) {
        const container = document.querySelector(`#${format}Section`);
        const list = container.querySelector(".swiper-wrapper");
        list.textContent = "";
        this.data.map((artist) => list.appendChild(artist.renderSwiperListItem()));
    }

    renderSingle(id, tracks) {
        const container = document.querySelector(`#artistSection`);
        const artist = this.get({ id });
        artist.renderSingleItem(container, tracks);
    }

    dispose() {
        this.data = [];
    }
}
